import React from 'react';
import { useTheme } from 'styled-components';
import { ModalAlerts } from '../../alerts/modal/alerts';
import { getOpacity } from '../../../../theme/utils/get-rgb';

type ModalContentType = {
    children: React.ReactNode;
};

export const ModalContent: React.FC<ModalContentType> = ({ children }: ModalContentType) => {
    const theme = useTheme();

    return (
        <div
            className="modal-content-fade relative flex flex-1 overflow-hidden before:pointer-events-none before:absolute before:left-0 before:right-0 before:top-0 before:z-[200] before:h-small before:content-[''] after:pointer-events-none after:absolute after:bottom-0 after:left-0 after:right-0 after:z-[200] after:h-small after:rounded-b-medium after:content-[''] md:before:h-[3.2rem] md:after:h-[3.2rem]"
            style={
                {
                    '--modal-fade-top': `linear-gradient(180deg, ${getOpacity(
                        theme.palette.background.body,
                        1,
                    )} 0%, ${getOpacity(theme.palette.background.body, 0)} 100%)`,
                    '--modal-fade-bottom': `linear-gradient(180deg, ${getOpacity(
                        theme.palette.background.body,
                        0,
                    )} 0%, ${getOpacity(theme.palette.background.body, 1)} 100%)`,
                } as React.CSSProperties
            }
        >
            <style>{`
                .modal-content-fade::before {
                    background: var(--modal-fade-top);
                }

                .modal-content-fade::after {
                    background: var(--modal-fade-bottom);
                }
            `}</style>
            <div className="relative z-[100] flex-1 overflow-auto p-small md:p-[3.2rem]">
                <ModalAlerts />
                {children}
            </div>
        </div>
    );
};
